import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  noDataState: {
    width: "100%",
    minHeight: 120,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "16px 0",
    padding: "24px",
    color: "var(--color-text-secondary)",
    textAlign: "center",
  },
  errorText: {
    fontWeight: 800,
    color: "var(--error-color)",
    marginRight: 8,
  },
  messageText: {
    fontWeight: 600,
    fontSize: 14,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  }
}));
